import axios from 'axios';
import { HttpClient } from '@/api/HttpClient';
import { UserApi } from '@/api/user/user.api';
import { AuthApi } from '@/api/auth/auth.api';
import { getApiBaseUrl } from '@/api/getApiBaseUrl';
import applyCaseMiddleware from 'axios-case-converter';

export const createAuthApiClient = () => {
  const apiBaseUrl = getApiBaseUrl();

  const axiosClient = axios.create({
    baseURL: apiBaseUrl,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

  const httpClient = new HttpClient(axiosClient);
  const authApi = new AuthApi(httpClient);

  return { authApi };
};

export const createAuthUserApiClient = () => {
  const apiBaseUrl = getApiBaseUrl();
  const isSwaProxyEnabled = import.meta.env.VITE_USE_SWA_PROXY === 'true';

  const axiosClient = axios.create({
    baseURL: apiBaseUrl,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  axiosClient.interceptors.request.use(
    config => {
      const authorization = config.headers?.Authorization || config.headers?.authorization;
      if (isSwaProxyEnabled && authorization) {
        config.headers['x-forwarded-authorization'] = authorization;
      } else {
        delete config.headers['x-forwarded-authorization'];
      }
      return config;
    },
    error => Promise.reject(error),
  );

  // middleware converts camelCase to snake_case on request (outgoing),
  // and snake_case to camelCase on response (incoming)
  const axiosInstanceWithApplyCaseMiddleware = applyCaseMiddleware(axiosClient, {
    preservedKeys: [], // example if we want to skip conversion for particular keys
  });

  const httpClient = new HttpClient(axiosInstanceWithApplyCaseMiddleware);
  const userApi = new UserApi(httpClient);

  return { userApi };
};
